const IN_REPLY_TO_SUBJECT_MAX_LENGTH = 60;

export function truncateSubject(subject: string): string {
  const trimmedSubject = subject.trim();
  return trimmedSubject.length <= IN_REPLY_TO_SUBJECT_MAX_LENGTH
    ? trimmedSubject
    : `${trimmedSubject.slice(0, IN_REPLY_TO_SUBJECT_MAX_LENGTH - 1)}…`;
}
